var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      version: 1
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 0.6c-1-0.8-2.4-0.8-3.4 0l-24.7 19.1c-0.7 0.5-1.1 1.3-1.1 2.2l0 30c0 2.2 0.9 4.3 2.4 5.8 1.5 1.5 3.6 2.4 5.8 2.4l38.5 0c2.2 0 4.3-0.9 5.8-2.4 1.5-1.5 2.4-3.6 2.4-5.8l0-30c0-0.8-0.4-1.6-1.1-2.2l-24.7-19.1Zm9.3 54l8.3 0c0.7 0 1.4-0.3 1.9-0.8 0.5-0.5 0.8-1.2 0.8-1.9l0-28.7 -22-17 -22 17 0 28.7c0 0.7 0.3 1.4 0.8 1.9 0.5 0.5 1.2 0.8 1.9 0.8l8.3 0 0-24.5c0-1.5 1.2-2.7 2.8-2.7l16.5 0c1.5 0 2.8 1.2 2.8 2.7l0 24.5Zm-16.5 0l0-21.8 11 0 0 21.8 -11 0Z"
  })));
};
export default SvgHome;